import clsx from 'clsx';

type InitialsAvatarProps = {
  name: string;
  className?: string;
};

function getInitials(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return '?';
  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

export default function InitialsAvatar({ name, className = '' }: InitialsAvatarProps) {
  const initials = getInitials(name);

  return (
    <div
      className={clsx('rounded-full overflow-hidden flex items-center justify-center shrink-0 bg-gray-500', className)}
    >
      <span className="font-semibold text-white select-none leading-none text-xl md:text-3xl">{initials}</span>
    </div>
  );
}
